(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const revealPopup = () => {
		const stickyBars = document.querySelectorAll('.sticky-bar'); // All sticky bars (desktop + mobile)
		const allBuyButtons = document.querySelectorAll('.product__buy_buttons .product-form__submit');
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBars.length || !allBuyButtons.length) {
			return;
		}

		// Find the currently visible buy button (to handle desktop/mobile duplicate sections)
		let buyButton = allBuyButtons[0];
		const visibleBtn = Array.from(allBuyButtons).find(btn => btn.offsetParent !== null);
		if (visibleBtn) {
			buyButton = visibleBtn;
		}

		const handleScroll = () => {
			const buyButtonRect = buyButton.getBoundingClientRect();
			const footerRect = footer ? footer.getBoundingClientRect() : null;

			// Show sticky bar when buy button is above viewport
			const buyButtonHidden = buyButtonRect.bottom < 0;

			// Hide sticky bar when footer is visible
			const footerVisible = footerRect && footerRect.top < window.innerHeight;

			// Additional check: ensure we really scrolled past the button
			// If buyButtonRect.bottom is 0, it might be happening because the element is hidden or detached (edge case protection)
			// But since we selected based on offsetParent, it should be fine.
			// However, if the element became hidden after selection (e.g. resize), rect would be all 0.
			// Validating rect height > 0 ensures we are looking at a rendered element.
			const isValidRect = buyButtonRect.height > 0;

			const shouldShow = isValidRect && buyButtonHidden && !footerVisible;

			stickyBars.forEach(bar => {
				bar.classList[shouldShow ? "add" : "remove"]('active');
			});
		};

		// Initial check in case the user starts in the middle of the page
		handleScroll();
	};

	document.addEventListener('scroll', () => revealPopup());

	const initDeliveryDate = () => {
		const deliveryElements = document.querySelectorAll('.product-delivery-date:not([data-initialized])');
		deliveryElements.forEach(el => {
			const threshold = parseInt(el.dataset.deliveryThreshold) || 0;
			const locale = el.dataset.deliveryLocale || 'fr-FR';
			const allowWeekend = el.dataset.deliveryWeekend === 'true';
			
			let deliveryDate = new Date();
			let daysAdded = 0;
			
			while (daysAdded < threshold) {
				deliveryDate.setDate(deliveryDate.getDate() + 1);
				if (allowWeekend) {
					daysAdded++;
				} else {
					const day = deliveryDate.getDay();
					if (day !== 0 && day !== 6) { // Not Sunday (0) and not Saturday (6)
						daysAdded++;
					}
				}
			}
			
			if (!allowWeekend) {
				while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6) {
					deliveryDate.setDate(deliveryDate.getDate() + 1);
				}
			}

			const options = { day: 'numeric', month: 'long' };
			const formattedDate = new Intl.DateTimeFormat(locale, options).format(deliveryDate);
			
			el.textContent = ` ${formattedDate}`;
			el.setAttribute('data-initialized', 'true');
		});
	};

	// Use MutationObserver for robust AJAX handling
	const observer = new MutationObserver((mutations) => {
		let shouldInit = false;
		for (const mutation of mutations) {
			if (mutation.addedNodes.length) {
				shouldInit = true;
				break;
			}
		}
		if (shouldInit) initDeliveryDate();
	});

	observer.observe(document.body, { childList: true, subtree: true });

	window.initDeliveryDate = initDeliveryDate;

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
		initDeliveryDate();
	});

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			initProductAccordion();
			initZoomImage();
			revealPopup();
			initDeliveryDate();
		});
	} else {
		initProductAccordion();
		initZoomImage();
		revealPopup();
		initDeliveryDate();
	}
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		// const inventory = this.productElement.querySelector(".product__inventory");
		// if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
